import React, { useContext } from 'react';

import { CalendarContext } from '../../context/CalendarContext.jsx';
import FilterCheckboxGroup from '../FilterCheckboxGroup/FilterCheckboxGroup.jsx';

import FilterDate from '../FilterDate/FilterDate.jsx';
import FilterFieldset from '../FilterFieldset/FilterFieldset.jsx';

function FilterDialog() {
  const { config, filter, filterCount, updateCategoriesFilter, handleUpdate, updateFilter, handleReset, isLoading, hasChanged } =
    useContext(CalendarContext);

  return (
    <div className="filter-dialog">
      <div className="filter-dialog__content">
        <h3 className="text text--subheading">{config.labels.filter}</h3>

        {!config.date.hideDateInput && config.dateSwitch.type !== 'range' && (
          <FilterFieldset
            label={config.labels.range}
            onReset={
              filter.date && (filter.date.from || filter.date.to)
                ? () => updateFilter((prev) => ({ ...prev, date: { from: undefined, to: undefined } }))
                : undefined
            }
            resetLabel={config.labels.reset}
          >
            <FilterDate />
          </FilterFieldset>
        )}

        {config.filter.map((item) => (
          <FilterFieldset
            label={item.label}
            key={item.handle}
            onReset={
              filter[item.type][item.handle].length > 0
                ? () => updateFilter((prev) => ({ ...prev, [item.type]: { ...prev[item.type], [item.handle]: [] } }))
                : undefined
            }
            resetLabel={config.labels.reset}
          >
            {item.component === 'checkbox' && (
              <FilterCheckboxGroup
                items={item.items}
                showLessLabel={config.labels.showLess}
                showMoreLabel={config.labels.showMore}
                selected={filter[item.type][item.handle]}
                id={item.handle}
                onChange={(value) => updateCategoriesFilter(item.handle, value)}
              />
            )}
          </FilterFieldset>
        ))}
      </div>

      {(hasChanged || filterCount > 0) && (
        <div className="filter-dialog__buttons">
          {hasChanged && (
            <button
              className="button filter-dialog__update"
              type="button"
              disabled={isLoading}
              onClick={handleUpdate}
              aria-controls={config.contentId}
            >
              <span>{config.labels.updateFilter}</span>
            </button>
          )}

          <button className="button filter-dialog__reset" type="button" disabled={isLoading} onClick={handleReset}>
            <span>{config.labels.resetFilter}</span>
          </button>
        </div>
      )}
    </div>
  );
}

export default FilterDialog;
